import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";
import {
	postMessageToRN,
	useRNHandler,
} from "../@utility/react-native.utility";

let timeout: NodeJS.Timeout;

const ReactNativeDeepLink = () => {
	const history = useHistory();
	// const location = useLocation();

	React.useEffect(() => {
		const timeout = setInterval(() => {
			if ((window as any)?.isReactNativeApp) {
				postMessageToRN("readyToNavigateInWebview", {
					isReady: true,
				});
				clearInterval(timeout);
			}
		}, 200);

		return () => {
			clearInterval(timeout);
		};
	}, []);

	const navigateToNewLink = useCallback(
		(payload: { to: string }) => {
			history.push(payload.to);
		},
		[history]
	);

	useRNHandler("navigateInWebView", navigateToNewLink);

	return null;
};

export default ReactNativeDeepLink;
